import React from "react";
import PropTypes from "prop-types";

const FolderMinusIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M5 4h3.558a2 2 0 0 1 1.898 1.368l.202.606A1.5 1.5 0 0 0 12.081 7H19a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
        <path strokeLinecap="round" d="M9 13h6" />
      </g>
    </g>
  </svg>
);

FolderMinusIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default FolderMinusIcon;
